import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useFormik } from "formik";
import { Helmet } from "react-helmet";
import * as Yup from "yup";
import "../EmailPopup/style.scss";
import "../style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRouting, formDataGenerator } from "../../../../../utils/common";
import { getsipSaheliPopup, getIAPWomenMCQ, RegisterSubmitMCQ, quizSaheliMeta } from "../actions";
import cookie from 'react-cookies';

const RegistrationQuiz = (props) => {
  const { getsipSaheliPopup, sipSaheliPopup, getIAPWomenMCQ, iapWomenMcq, RegisterSubmitMCQ, quizSaheliMeta, saheliSipMeta, submitRegisterData } = props;
  const [email, setEmail] = useState();
  const [sipData, setsipData] = useState();
  const [successModalShow, setSuccessModalShow] = useState(true);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [mcqData, setMcqData] = useState([]);
  const [correctMcq, setCorrectMcq] = useState([]);
  const [ratingValue, setratingValue] = useState('');
  const [submitData, setsubmitData] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [formData, setFormData] = useState({
    feedback: '',
    feedbackImprove: '',
  });
  const [errors, setErrors] = useState({});
  const [sipEmail, setsipEmail] = useState([]);
  const [sipLanguage, setsipLanguage] = useState([]);

  const utm_source = new URLSearchParams(window.location.search);
  const utmSources = utm_source.get("utm_source") || "";
  const utmMedium = utm_source.get("utm_medium") || "";
  const utmCampaign = utm_source.get("utm_campaign") || "";

  useEffect(()=>{
    const title = cookie.load('sipsaheliemail');
    const lang = cookie.load('sipsahelilanguage');
    if (title) {
      setsipEmail(title);
    }
    if(lang){
      setsipLanguage(lang)
    }
  },[])
  useEffect(() => {
    let tBot = document.querySelector('.bot');
    if (tBot) tBot.style.display = 'none';
    quizSaheliMeta('sip-saheli-quiz');
  }, []);

  // const validationSchema = Yup.object().shape({
  //   email: Yup.string()
  //     .email("email is not correct")
  //     .required("Please Enter your address details"),
  // });
  // const formik = useFormik({
  //   initialValues: {
  //     email: "",
  //   },
  //   validationSchema,
  //   onSubmit: (data) => {
  //     let payload = {
  //       email: data.email,
  //       language: ''
  //     };
  //     getsipSaheliPopup(formDataGenerator(payload));
  //   },
  // });

  // useEffect(() => {
  //   if (formik.values.email) {
  //     setEmail(formik.values.email);
  //   }
  // }, [formik.values.email]);
  
  useEffect(() => {
      // if (sipSaheliPopup && sipSaheliPopup.status && sipSaheliPopup.status == true) {
      //   setSuccessModalShow(false);
        let data = {
          language: cookie.load('sipsahelilanguage') == "English" ? '' : 'hi',
        }
        getIAPWomenMCQ(formDataGenerator(data));
      // }
    // }
  }, []);
 
  // useEffect(()=>{
  //   if (sipSaheliPopup) {
  //     setsipData(sipSaheliPopup);
  //   }
  // },[sipSaheliPopup])
  useEffect(()=>{
    if (submitRegisterData) {
      setsubmitData(submitRegisterData);
    }
  },[submitRegisterData])
  // useEffect(()=>{
  //   if (sipEmail.length > 0) {
  //     let payload = {
  //       email: sipEmail,
  //       language: ''
  //     };
  //     getsipSaheliPopup(formDataGenerator(payload));
  //   }
  // },[sipEmail])
  useEffect(() => {
    if (iapWomenMcq && iapWomenMcq.length > 0) {
      setMcqData(iapWomenMcq);
    }
  }, [iapWomenMcq]);

  // useEffect(() => {
  //   if (formik.values.email == "" || formik.values.email) {
  //     setsipData();
  //   }
  // }, [formik.values.email]);

  const handleSubmit = () => {
    setSubmitted(true);
    const optionLabels = ["a", "b", "c", "d"];
    const updatedMcqData = mcqData && mcqData.map((question) => {
      const selectedAnswer = selectedAnswers && selectedAnswers[question.question];
      return {
        ...question,
        answer: question.answer.map((ans, index) => ({
          ...ans,
          userAnswer: optionLabels[index] === selectedAnswer ? true : false,
        })),
      };
    });

    const correctArray = updatedMcqData && updatedMcqData.filter((question) =>
      question.answer.some((ans) => ans.userAnswer == true && ans.rightAnswer == true)
    );
    setCorrectMcq(correctArray);
    setMcqData(updatedMcqData);
    let payload = {
      email: sipEmail,
      mcqAnswers: JSON.stringify(selectedAnswers),
      language: sipLanguage == "English" ? 'English' : 'Hindi',
      rating: ratingValue,
      feedback: formData.feedback ? formData.feedback : '',
      feedbackImprove: formData.feedbackImprove ? formData.feedbackImprove : '',
      utm_source: utmSources.toString(),
      utm_medium: utmMedium.toString(),
      utm_campaign: utmCampaign.toString(),
    };
    RegisterSubmitMCQ(formDataGenerator(payload));
    setShowLoader(true);
    // Remove the cookie
    cookie.remove('sipsaheliemail', { path: '/' });
    cookie.remove('sipsahelilanguage', { path: '/' });
  };
  const handleAnswerClick = (questionIndex, answerIndex) => {
    const optionLabels = ["a", "b", "c", "d"];
    setSelectedAnswers((prevAnswers) => ({
      ...prevAnswers,
      [mcqData && mcqData[questionIndex].question]: optionLabels[answerIndex],
    }));
  };
  const handleRatingFeedback = async (e, value) => {
    setratingValue(value);
  };

  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'feedback':
        if (!value) {
          error = 'Required';
        }
        break;
      case 'feedbackImprove':
        if (!value) {
          error = 'Required';
        }
        break;
      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    validateField(name, value);
  };

  return (
    <div className="wrapper">
      {saheliSipMeta && saheliSipMeta.data && saheliSipMeta.data.meta &&
        <Helmet>
          <title>{saheliSipMeta.data.meta.title ? saheliSipMeta.data.meta.title : ""}</title>
          <meta name="description"
            content={
              saheliSipMeta.data.meta.description ? saheliSipMeta.data.meta.description : ""
            }
          />
          <meta name="keywords"
            content={
              saheliSipMeta.data.meta.keywords ? saheliSipMeta.data.meta.keywords : ""
            }
          />
          <meta property="og:title"
            content={
              saheliSipMeta.data.meta.og_title ? saheliSipMeta.data.meta.og_title : ""
            }
          />
          <meta property="og:description"
            content={
              saheliSipMeta.data.meta.og_description ? saheliSipMeta.data.meta.og_description : ""
            }
          />
          <meta property="og:image"
            content={
              saheliSipMeta.data.meta.og_image ? saheliSipMeta.data.meta.og_image : ""
            }
          />
          <meta property="og:url"
            content={
              saheliSipMeta.data.meta.og_url ? saheliSipMeta.data.meta.og_url : ""
            }
          />
        </Helmet>}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <h1 className="me-auto">
              SIP <span>Saheli</span>
            </h1>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  <a href="/sipsaheli">SIP Saheli</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <div className="container">
        <h2 className="text-center maintitle">Test your knowledge!</h2>
        <div className="mcqDiv">
          {submitted && correctMcq && correctMcq.length > 1 ? (
            <div className="congodiv">
              <h3>Congratulation!</h3>
              <p>You did amazing work, below is your score</p>
              <h3 className="score">{correctMcq && correctMcq.length}/{mcqData && mcqData.length}</h3>
            </div>
          ) : ""}
          {mcqData &&
            mcqData.length > 0 &&
            mcqData.map((quest, index) => {
              return (
                <div className="mb-3 d-flex">
                  <div className="numberdiv">
                    <p className="number">{index + 1}</p>
                  </div>
                  <div className="ms-3 w-100">
                    <h3 className="d-flex mb-3">{quest.question}</h3>
                    <div className="row">
                      {quest && quest.answer && quest.answer.map((ans, ansindex) => (
                        <div key={`${index}-${ansindex}`} className="col-md-6">
                          <div className={`d-flex align-items-center justify-content-between p-2 mb-2 ${ans && (ans.userAnswer == true && ans.rightAnswer == true) || (ans.userAnswer == false && ans.rightAnswer == true) ? "correct" : ans.userAnswer == true && ans.rightAnswer == false ? "incorrect" : ""}`}>
                            <div className="d-flex align-items-start">
                              <input
                                type="radio"
                                className="mt-1 cursorp"
                                name={`answer-${index}`}
                                disabled={submitted}
                                checked={selectedAnswers[quest.question] === ["a", "b", "c", "d"][ansindex]}
                                onClick={() => handleAnswerClick(index, ansindex)}
                              />
                              <p className="ms-2 cursorp" onClick={() => handleAnswerClick(index, ansindex)}>{ans.options}</p>
                            </div>
                            {ans &&
                              (ans.userAnswer == true && ans.rightAnswer == true)
                              || (ans.userAnswer == false && ans.rightAnswer == true) ?
                              <p className="green">Correct</p>
                              : ""}
                            {ans && ans.userAnswer == true && ans.rightAnswer == false ?
                              <p className="red">Wrong</p>
                              : ''}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )
            })}
          <div className="row mb-4 bordertop">
            <p className="mainheading mb-3">Please share your valuable feedback for the masterclass.</p>
            <div className="col-md-6">
              <div className="interest mt-2">
                <h2 className="mb-2">
                  Overall ratings (Rating 1-5)<span className="astric">*</span>
                </h2>
                <div className="d-flex">
                  <div
                    onClick={(e) => handleRatingFeedback(e, "1")}
                    className={ratingValue == "1" ? "scale d-flex flex-column justify-content-center me-1 me-md-3 cursorp" : "d-flex flex-column justify-content-center me-1 me-md-3 cursorp"}
                  >
                    <img src="/images/New/learnNew/Interest1.svg" />
                    <p className="text-center">1</p>
                  </div>
                  <div
                    className={ratingValue == "2" ? "scale d-flex flex-column justify-content-center me-1 me-md-3 cursorp" : "d-flex flex-column justify-content-center me-1 me-md-3 cursorp"}
                    onClick={(e) => handleRatingFeedback(e, "2")}
                  >
                    <img src="/images/New/learnNew/Interest2.svg" />
                    <p className="text-center">2</p>
                  </div>
                  <div
                    className={ratingValue == "3" ? "scale d-flex flex-column justify-content-center me-1 me-md-3 cursorp" : "d-flex flex-column justify-content-center me-1 me-md-3 cursorp"}
                    onClick={(e) => handleRatingFeedback(e, "3")}
                  >
                    <img src="/images/New/learnNew/Interest3.svg" />
                    <p className="text-center">3</p>
                  </div>
                  <div
                    className={ratingValue == "4" ? "scale d-flex flex-column justify-content-center me-1 me-md-3 cursorp" : "d-flex flex-column justify-content-center me-1 me-md-3 cursorp"}
                    onClick={(e) => handleRatingFeedback(e, "4")}
                  >
                    <img src="/images/New/learnNew/Interest4.svg" />
                    <p className="text-center">4</p>
                  </div>
                  <div
                    className={ratingValue == "5" ? "scale d-flex flex-column justify-content-center me-1 me-md-3 cursorp" : "d-flex flex-column justify-content-center me-1 me-md-3 cursorp"}
                    onClick={(e) => handleRatingFeedback(e, "5")}
                  >
                    <img src="/images/New/learnNew/Interest5.svg" />
                    <p className="text-center">5</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="feedbackdiv">
              <div className="mb-3">
                <p>
                  What did you like in the session.<span className="astric">*</span>
                </p>
                <textarea
                  name="feedback"
                  rows="2"
                  cols="50"
                  placeholder="Enter message here"
                  className="form-control"
                  // maxLength="500"
                  value={formData.feedback}
                  onChange={handleChange}
                >
                </textarea>
                {errors.feedback && <div className="errorFormFields">
                  {errors.feedback}
                </div>}
              </div>
              <div>
                <p>
                  What can we improve.<span className="astric">*</span>
                </p>
                <textarea
                  name="feedbackImprove"
                  rows="2"
                  cols="50"
                  placeholder="Enter message here"
                  className="form-control"
                  // maxLength="500"
                  value={formData.feedbackImprove}
                  onChange={handleChange}
                >
                </textarea>
                {errors.feedbackImprove && <div className="errorFormFields">
                  {errors.feedbackImprove}
                </div>}
              </div>
            </div>
          </div>
          <div>
            {submitted && submitData && submitData.status ?(
              <a href={submitData && submitData.pdfUrl} target='_blank'> <span className="thankyou">Thank You! </span>
                <button className="submitbtn">
                  Download Certificate
                </button>
              </a>
            ) : (
              <>
              {showLoader ? 
                <button
                  // onClick={handleSubmit}
                  className="submitbtn d-flex cursordisable"
                  loading={showLoader}
                  disabled={!(ratingValue && Object.values(errors).every(error => error === '') && Object.values(formData).every(value => value !== '') && selectedAnswers && mcqData && mcqData.length > 0 && Object.keys(selectedAnswers).length == mcqData.length)}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 13 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="spinnerloader"
                  >
                    <path
                      d="M4.38798 12.616C3.36313 12.2306 2.46328 11.5721 1.78592 10.7118C1.10856 9.85153 0.679515 8.82231   0.545268 7.73564C0.411022 6.64897 0.576691 5.54628 1.02433 4.54704C1.47197 3.54779 2.1845 2.69009 3.08475   2.06684C3.98499 1.4436 5.03862 1.07858 6.13148 1.01133C7.22435 0.944078 8.31478 1.17716 9.28464    1.68533C10.2545 2.19349 11.0668 2.95736 11.6336 3.89419C12.2004 4.83101 12.5 5.90507 12.5 7"
                      stroke="white"
                    />
                  </svg>
                  Generating Certificate!
                </button>
                :
                <button
                  onClick={handleSubmit}
                  className="submitbtn"
                  disabled={!(ratingValue && Object.values(errors).every(error => error === '') && Object.values(formData).every(value => value !== '') && selectedAnswers && mcqData && mcqData.length > 0 && Object.keys(selectedAnswers).length == mcqData.length)}
                >
                  Submit
                </button>
              }
              </>
            )}
          </div>
        </div>
      </div>
      {/* <Modal
        isOpen={successModalShow}
        contentLabel="Example Modal"
        className="nameModal"
      >
        <div className="container">
          <form onSubmit={formik.handleSubmit}>
            <p className="maintext">Please enter your registered email to proceed</p>
            <div className="d-flex align-items-center justify-content-center">
              <p>Email: </p>
              <div>
                <input
                  type="text"
                  placeholder="Email Address"
                  name="email"
                  // onChange={formik.handleChange}
                  // value={formik.values.email}
                  className={
                    "invalid form-control ms-3" +
                    (formik.errors.email && formik.touched.email
                      ? " is-invalid"
                      : "")
                  }
                />
                <div className="invalid-feedback ms-3">
                  {formik.errors.email && formik.touched.email
                    ? formik.errors.email
                    : null}
                </div>
                {sipData && sipData.status == false ? (<p className="error ms-3">{sipData.message}</p>) : ""}
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button className="Submitbtn" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </Modal> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  // sipSaheliPopup: state.iapWomen.sipPopData,
  iapWomenMcq: state.iapWomen.iapWomenMCQ,
  saheliSipMeta: state.iapWomen.saheliMetaData,
  submitRegisterData: state.iapWomen.registrationSubmit
});

const mapDispatchToProps = (dispatch) => ({
  // getsipSaheliPopup: bindActionCreators(getsipSaheliPopup, dispatch),
  getIAPWomenMCQ: bindActionCreators(getIAPWomenMCQ, dispatch),
  RegisterSubmitMCQ: bindActionCreators(RegisterSubmitMCQ, dispatch),
  quizSaheliMeta: bindActionCreators(quizSaheliMeta, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationQuiz);